import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';
import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    Form,
    Input,
    Table,
    Select,
    Menu,
    InputNumber,
    DatePicker,
} from 'antd';
import { 
  ExclamationCircleFilled, 
  ProductOutlined,
  MinusCircleOutlined, 
  PlusOutlined 
} from '@ant-design/icons';
import { 
  ArrowBack,
} from '@mui/icons-material';
import { 
  // MoreVert, 
  BorderColor 
} from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { 
  useNavigate,
  useParams,
 } from "react-router-dom"
// import { formatDate } from '../../Utils/Common';
import dayjs from 'dayjs';
// import { refreshPage } from '../../Utils/Common';

const { RangePicker } = DatePicker;
const { Item, List } = Form;
const { Option } = Select;
const { Search, TextArea } = Input;
const { confirm } = Modal;

const FunGolfPlayer = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [playerDisabled, setPlayerDisabled] = useState(true);
  const [editTournament, setEditTournament] = useState(false);
  const [playerId, setPlayerId] = useState([]);
  const [pageSize, setPageSize] = useState('');
  const [invitationalId, setInvitationalId] = useState('');
  const [invitationalDetails, setInvitationalDetails] = useState({
      name: '',
      date:'',
      remarks:'',
  });
  const [playerDetails, setPlayerDetails] = useState({
      name: '',
      date:'',
      remarks:'',
  });
  const [filterConfig, setFilterConfig] = useState({
    invitational_player_id: '',
    tournament_id: id,
    page: 1,
  })
  const [playerData, setPlayerData] = useState([])
  const [tournament, setTournament] = useState([])

  const [addForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const [editTournamentForm] = Form.useForm();
  const [action, setAction] = useState("");
  const { callPost, loading, data } = usePostRequest(()=>{
    fetchPlayerData()
    addForm.resetFields();
    editForm.resetFields();
    editTournamentForm.resetFields();
    setAddVisible(false);
    setEditVisible(false);
    setEditTournament(false);
    setIsDisabled(true);
  });
  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;
  const columns = [
    {
      title: 'Players',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      sorter: (a, b) => a.players.localeCompare(b.players),
    },
    {
      title: 'HDC',
      dataIndex: 'hdc',
      key: 'hdc',
      align: 'center',
      // sorter: (a, b) => a.hdc.localeCompare(b.hdc),
    },
    {
      title: 'Division',
      dataIndex: 'division_name',
      key: 'division_name',
      align: 'center',
      sorter: (a, b) => a.division_name.localeCompare(b.division_name),
    },
  ];

  async function fetchPlayerData() {
    setIsLoading(true)
    const response = await UseGetRequest("fun_golf_players/get", filterConfig);
    if (response?.data) {
      setPlayerData(response?.data?.data);
      setPageSize(response?.data?.size)
    } else {
      setPlayerData([])
    }

    setIsLoading(false);
  }

  const showAddModal = () => {
    setAddVisible(true);
  };

  const handleAddCancel = () => {
    addForm.resetFields();
    setAddVisible(false);
  };

  const handleEditCancel = () => {
    editForm.resetFields();
    setEditVisible(false);
  };

  const handleAddOk = () => {
    addForm.validateFields().then(values => {
        const data = {
          division_id: values.division_id,
          // name: values.name,
          // hdc: values.hdc,
          names: values?.player?.map((item)=>item.names),
          hdcs: values?.player?.map((item)=>item.hdcs),
        }

        var finalValues = Object.entries(data).map(([key, value]) => ({
            key,
            value,
        }));

        callPost(
            "fun_golf_players/add_multiple", 
            finalValues,
            true
        );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };
  
  const handleEditOk = () => {
    editForm.validateFields().then(values => {
      const data = {
          division_id: values.division_id,
          name: values.name,
          hdc: values.hdc,
          player_id: playerId,
      }
      var finalValues = Object.entries(data).map(([key, value]) => ({
          key,
          value,
      }));
      callPost(
        "fun_golf_players/update", 
        finalValues,
        true
      );      
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showEditModal = (invitational_data) => {
    setPlayerId(invitational_data?.player_id) 
    setPlayerDetails(() => ({
      division_id: invitational_data.division_id,
      name: invitational_data?.name,
      player_id: invitational_data?.id,
      hdc: invitational_data?.hdc,
    }));     

    editForm.setFieldsValue({
      division_id: invitational_data?.division_id,
      name: invitational_data?.name,
      player_id: invitational_data?.id,
      hdc: invitational_data?.hdc,
    });
    setEditVisible(true);
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Do you want to permanently remove this Player?',
      icon: <ExclamationCircleFilled/>,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      confirmLoading: loading,
      onOk() {
        callPost(
          "fun_golf_players/delete", 
          {fun_golf_player_id: id},
          false
        );
      },
    });
  };

  async function fetchTournamentData() {
    setIsLoading(true)
    const response = await UseGetRequest("tournaments/get",{tournament_id: id});
    if (response?.data) {
      setTournament(response?.data?.data[0]);
    } else {
      setTournament([])
    }

    setIsLoading(false);
  }

  const handleEditTournamentClose = () => {
    setEditTournament(false)
    setIsDisabled(true)
  };

  const handleEditTournament = () => {
    editTournamentForm.validateFields().then(values => {
      const data = {
        name: values.name,
        remarks: values.remarks || '',
        date_from: values.date[0].format('YYYY-MM-DD'),
        date_to: values.date[1].format('YYYY-MM-DD'),
        division_names: values?.divisions?.map((item)=>item.division_names),
        game_type: "Fun Golf",
        tournament_id: invitationalId
      }
      var finalValues = Object.entries(data).map(([key, value]) => ({
        key,
        value,
    }));
      callPost(
        "tournaments/update", 
        finalValues,
        true
      );      
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showDeleteTournament= (id) => {
    confirm({
      title: 'Do you want to permanently remove this Tournament?',
      icon: <ExclamationCircleFilled/>,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      confirmLoading: loading,
      onOk() {
        setAction("delete");
        callPost(
          "tournaments/delete", 
          {tournament_id: id},
          false
        );
        setAction("delete")
      },
     
    });
  };

  const showEditTournament = (id, invitational_data) => {
    setEditTournament(true)
    setInvitationalId(id) 
    setInvitationalDetails(() => ({
      name: invitational_data.name,
      date: [
        invitational_data.date_from ? dayjs(invitational_data.date_from, 'YYYY/MM/DD') : undefined,
        invitational_data.date_to ? dayjs(invitational_data.date_to, 'YYYY/MM/DD') : undefined,
      ],
      remarks: invitational_data.remarks,
      divisions: invitational_data.divisions,
    }));     
    
    editTournamentForm.setFieldsValue({
        name: invitational_data.name,
        date: [
            invitational_data.date_from ? dayjs(invitational_data.date_from, 'YYYY/MM/DD') : undefined,
            invitational_data.date_to ? dayjs(invitational_data.date_to, 'YYYY/MM/DD') : undefined,
        ],
        remarks: invitational_data.remarks,
        divisions: invitational_data.divisions,
    });
  };

  const menu = (
    <Menu>
      <Menu.Item 
        onClick={showAddModal} 
        key="1"
      >
        Add Player
      </Menu.Item>
      <Menu.Item 
        onClick={() => navigate('/fun-golf/scorecard/' + id)}
        key="2"
      >
        Add Score
      </Menu.Item>
      <Menu.Item 
        onClick={() => navigate('/fun-golf/summary/' + id)}
        key="3"
      >
        View Summary
      </Menu.Item>
    </Menu>
  );

  const validateSpaces = (_, value) => {
    if (value && value.trim().length === 0) {
      return Promise.reject('Please enter a value other than spaces');
    } else {
      return Promise.resolve();
    }
  };

  const onSearch = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e.target.value || ''
      }
    ));
  };  

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchPlayerData();
    fetchTournamentData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  useEffect(() => {
    if (data && action==="delete") {
      navigate('/fun-golf')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, action])

  return (
    <Layout className='page'>
        <Navbar navKey={'fun_golf_nav'}/>
        <Layout className='content-container overflow-y'>
          <Row className='custom-padding responsive-tab-inline'>
            <Col span={15} className='header-container'>
              <Space>
                <ArrowBack className='cursor' onClick={() => navigate('/fun-golf')}/>
                {tournament.name && tournament.name.toUpperCase()}
                <BorderColor className='cursor' onClick={() => showEditTournament(id, tournament)}/>
              </Space>
            </Col>
            <Col span={9} className='mt-2 responsive-tab-width' align='end'>
              <Space className='responsive-inline'> 
                <Search
                  placeholder="Search..."
                  size='medium'
                  onChange={(e)=>onSearch(e)}
                  className='responsive-header-input'
                />      
                <Dropdown
                  overlay={menu}
                  trigger={['click']}
                >
                  <Button type="primary" onClick={(e) => e.preventDefault()}>
                    <Space>
                      + Action
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
          <Row className='page-content'>
            <Col span={24} className='responsive-overflow-auto'>
               <Table 
                columns={columns} 
                dataSource={playerData} 
                loading={{
                  indicator: customSpinner, // Use custom spinner
                  spinning: isLoading, // Set spinning based on loading state
                }}
                pagination={{
                  defaultPageSize: 10,
                  // showQuickJumper: true,
                  // showSizeChanger: true,
                  total: pageSize,
                  current: filterConfig?.page,
                  pageSize: filterConfig?.total_records_per_page,
                }}
                onChange={handleTableChange}
                onRow={(record, rowIndex) => {
                  return {
                    className: 'cursor',
                    onClick: () => showEditModal(record),
                  };
                }}
              />
            </Col>
          </Row>
        </Layout>
        <Modal
          title="Add Player"
          confirmLoading={loading}
          open={addVisible}
          onOk={handleAddOk}
          onCancel={handleAddCancel}
          okText="Submit"
          maskClosable={false}
        >
          <Row>
            <Col span={24} align='center'>
                {tournament.name}
            </Col>
          </Row>
          <Form 
            form={addForm} 
            layout="vertical"
            initialValues={{
              player: [{}]  // This initializes the `player` field with one empty object, creating one default row.
            }}
          >
            <Item
                label="Division"
                name="division_id"
                rules={[
                  { required: true, message: 'Please enter your Division!' },
                ]}
                
            >
              <Select 
                placeholder="Select a Division" 
                // onChange={(e) => handleProperty(e)}
                showSearch
                filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {tournament?.divisions?.map((option) => (
                    <Option key={option.division_id} value={option.division_id}>{option.division_names}</Option>
                ))}
              </Select>
            </Item>
            <Form.List label="Player" name="player">
              {(fields, { add, remove }) => (
                  <>
                      {fields.map(({ key, name, ...restField }) => (
                          <Space key={key} style={{ display: 'flex', marginBottom: 8, width: '150%' }} align="baseline">
                              <Form.Item
                                  {...restField}
                                  name={[name, 'names']}
                                  rules={[{ required: true, message: 'Please input Player Name!' }]}
                              >
                                  <Input placeholder="Enter Player Name" />
                              </Form.Item>
                              <Form.Item
                                  {...restField}
                                  name={[name, 'hdcs']}
                                  rules={[
                                      { required: true, message: 'Please enter your Player HDC!' },
                                  ]}
                              >
                                  <InputNumber
                                      min={0}
                                      max={28}
                                      placeholder="Enter HDC"
                                      style={{ width: '80%' }}
                                  />
                              </Form.Item>
                              {fields.length > 1 && (
                                  <MinusCircleOutlined onClick={() => remove(name)} />
                              )}
                          </Space>
                      ))}
                      <Form.Item>
                          <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                              Add Player
                          </Button>
                      </Form.Item>
                  </>
              )}
            </Form.List>
            {/* <Row>
              <Col span={19} className='pe-2'>
                <Item
                  label="Player Name"
                  name="name"
                  rules={[
                      { 
                          required: true, message: 'Please enter your Player Name!' 
                      },
                  ]}
                >
                  <Input/>
                </Item>
              </Col>
              <Col span={5} className='ps-2'>
                <Item
                  label="HDC"
                  name="hdc"
                  rules={[
                    { 
                        required: true, message: 'Please enter your Player HDC!' 
                    },
                ]}
                >
                  <InputNumber
                    min={0}
                    max={28}
                  />
                </Item>
              </Col>
            </Row> */}
          </Form>
        </Modal>
        <Modal
          title="Edit Player"
          confirmLoading={loading}
          open={editVisible}
          // onOk={handleEditOk}
          onCancel={handleEditCancel}
          okText="Save"
          maskClosable={false}
          footer={null}
        >
          <Row>
            <Col span={24} align='center'>
                {tournament.name}
            </Col>
          </Row>
          <Form 
            form={editForm} 
            layout="vertical"
            initialValues={playerDetails}
          >
             <Item
                label="Division"
                name="division_id"
                rules={[
                  { required: true, message: 'Please enter your Division!' },
                ]}
                
            >
                <Select 
                  placeholder="Select a Division" 
                  // onChange={(e) => handleProperty(e)}
                  showSearch
                  filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
                  disabled={playerDisabled}
                >
                  {tournament?.divisions?.map((option) => (
                      <Option key={option.division_id} value={option.division_id}>{option.division_names}</Option>
                  ))}
                </Select>
            </Item>
            <Row>
              <Col span={19} className='pe-2'>
                <Item
                  label="Player Name"
                  name="name"
                  rules={[
                      { 
                          required: true, message: 'Please enter your Player Name!' 
                      },
                  ]}
                >
                  <Input
                    disabled={playerDisabled}
                  />
                </Item>
              </Col>
              <Col span={5} className='ps-2'>
                <Item
                  label="HDC"
                  name="hdc"
                  rules={[
                    { 
                        required: true, message: 'Please enter your Player HDC!' 
                    },
                ]}
                >
                  <InputNumber
                    min={0}
                    max={28}
                    disabled={playerDisabled}
                  />
                </Item>
              </Col>
            </Row>
          </Form>
        <Row>
         <Col span={24} align='right'>
          <Space>
            <Button
              className='delete-btn'
              onClick={() => showDeleteConfirm(playerId)}
            >
              Delete
            </Button>
            {
              playerDisabled ? (
                <Button
                  className='edit-btn'
                  onClick={() => setPlayerDisabled(false)}>
                  Edit
                </Button>
              ) : (
                <Button 
                  className='edit-btn'
                  onClick={() => setPlayerDisabled(true)}
                >
                  View
                </Button>
              )
            }
            {
              !playerDisabled && (
                <Button 
                  className='edit-btn'
                  onClick={handleEditOk}
                >
                  Save
                </Button>
              )
            }
          </Space>
         </Col>
        </Row>
      </Modal>
      <Modal
        title="Edit Tournament"
        confirmLoading={loading}
        open={editTournament}
        // onOk={handleEditTournament}
        onCancel={handleEditTournamentClose}
        okText="Save"
        maskClosable={false}
        footer={null}
        className='edit-modal'
      >
        <Form 
          form={editTournamentForm} 
          layout="vertical"
          initialValues={invitationalDetails}
        >
         
          <Row>
            <Col span={11}>
              <Item
                  label="Name"
                  name="name"
                  rules={[
                  { required: true, message: 'Please enter your Name!' },
                  { validator: validateSpaces }
                  ]}
                  
              >
                  <Input disabled={isDisabled} />
              </Item>
            </Col>
            <Col span={2}></Col>
            <Col span={11}>
              <Item
                label="Date"
                name="date"
                rules={[
                    { 
                        required: true, message: 'Please enter your Date Range!' 
                    },
                ]}
              >
                <RangePicker  
                    style={{width:'100%'}}
                    placeholder={['Date From', 'Date To']}
                    format={'YYYY/MM/DD'}
                    disabled={isDisabled}
                />
              </Item>
            </Col>
          </Row>
          <Item
              label="Remarks"
              name="remarks"
          >
              <TextArea rows={3} disabled={isDisabled}/>
          </Item>
          <label className='mb-2'><span className='logout-icon me-1'>*</span>Divisions</label>
          <List label="Division" name="divisions">
              {(fields, { add, remove }) => (
                  <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                          <Row key={key} style={{ display: 'flex', marginBottom: 8}} align="baseline">
                            <Col span={11}>
                              <Item
                                {...restField}
                                name={[name, 'division_names']}
                                fieldKey={[fieldKey, 'division_names']}
                                rules={[{ required: true, message: 'Please input division!' }]}
                               >
                                <Input 
                                    placeholder="Enter Division" 
                                    style={{
                                        width: '100%',
                                    }}
                                    disabled={isDisabled}
                                />
                              </Item>
                            </Col>
                            <Col span={1}></Col>
                            <Col span={11}>
                              {(fields.length > 1 && !isDisabled)? (
                                <MinusCircleOutlined className='logout-icon' onClick={() => remove(name)} />
                              ) : null}
                            </Col>
                          </Row>
                      ))}
                      <Item>
                          <Button disabled={isDisabled} type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                              Add Division
                          </Button>
                      </Item>
                  </>
              )}
          </List>
        </Form>
        <Row>
         <Col span={24} align='right'>
          <Space>
            <Button
              className='delete-btn'
              onClick={() => showDeleteTournament(id)}
            >
              Delete
            </Button>
            {
              isDisabled ? (
                <Button
                  className='edit-btn'
                  onClick={() => setIsDisabled(false)}>
                  Edit
                </Button>
              ) : (
                <Button 
                  className='edit-btn'
                  onClick={() => setIsDisabled(true)}
                >
                  View
                </Button>
              )
            }
            {
              !isDisabled && (
                <Button 
                  className='edit-btn'
                  onClick={handleEditTournament}
                >
                  Save
                </Button>
              )
            }
          </Space>
         </Col>
        </Row>
      </Modal>
    </Layout>
  )
}

export default FunGolfPlayer